import AbstractComponent from "./abstract-component";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const DESKTOP_BREAKPOINT = 1000;

export default class Accordion extends AbstractComponent {
	constructor(el) {
		super(el);
		this.triggers = [];
		this.mm = null;

		this.initDomElements();
		if (!this.cards.length) return;

		this.setup = this.setup.bind(this);
		this.onRefresh = () => ScrollTrigger.refresh();
		this.handleResize = () => {
			clearTimeout(this.resizeTimer);
			this.resizeTimer = setTimeout(this.setup, 150);
		};

		this.setup();
		window.addEventListener("resize", this.handleResize);
		window.addEventListener("orientationchange", this.onRefresh);
		window.addEventListener("load", this.onRefresh, { passive: true });
	}

	initDomElements() {
		this.stack = this.$el.querySelector(".js-accordion-stack");
		this.cards = [...this.$el.querySelectorAll(".js-accordion-card")];
		this.containers = [...this.$el.querySelectorAll(".js-accordion-card-container")];
	}

	cleanup() {
		this.triggers.forEach((t) => t.kill());
		this.triggers = [];
		this.mm?.revert();
		this.mm = null;
	}

	setupDesktop() {
		this.containers.forEach((container, index) => {
			gsap.set(container, { rotation: index % 2 === 0 ? 3 : -3 });
		});

		gsap.delayedCall(0.1, () => {
			this.cards.forEach((card, index) => {
				if (index < this.cards.length - 1) {
					this.triggers.push(
						ScrollTrigger.create({
							trigger: card,
							start: "top top",
							endTrigger: this.cards[this.cards.length - 1],
							end: "top top",
							pin: true,
							pinSpacing: false,
							scrub: 1,
						})
					);
				}
			});
		});
	}

	setupMobile() {
		this.cards.forEach((card) => gsap.set(card, { clearProps: "all" }));
		this.containers.forEach((container) => gsap.set(container, { clearProps: "all" }));
		ScrollTrigger.refresh();
	}

	setup() {
		this.cleanup();

		this.mm = gsap.matchMedia();
		this.mm.add(`(min-width: ${DESKTOP_BREAKPOINT}px)`, () => {
			this.setupDesktop();
			return () => {
				this.triggers.forEach((t) => t.kill());
				this.triggers = [];
			};
		});

		this.mm.add(`(max-width: ${DESKTOP_BREAKPOINT - 1}px)`, () => {
			this.setupMobile();
		});
	}

	destroy() {
		clearTimeout(this.resizeTimer);
		window.removeEventListener("resize", this.handleResize);
		window.removeEventListener("orientationchange", this.onRefresh);
		window.removeEventListener("load", this.onRefresh);
		this.cleanup();
	}
}
